module.exports = __webpack_public_path__ + "img/background-login.bc77fed5.jpeg";